export default __webpack_public_path__ + "static/media/house2.cd350d2c.jpg";